package pl.decks.personal.pages.ievp

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import pl.decks.posthog.client.PostHogClient
import kotlin.takeIf

class IEVPPageController {
    var uiState by mutableStateOf(IEVPPageState())
        private set

    fun handleEvent(e: IEVPPageEvent) = when (e) {
        is IEVPPageEvent.SectionClicked -> uiState = uiState.copy(scrollToSection = e.section)
        is IEVPPageEvent.ScrollToSectionConsumed -> uiState = uiState.copy(scrollToSection = null)
        is IEVPPageEvent.SectionMeasuresChanged -> {
            val newSectionProgress = uiState.sectionProgress + (e.section to e.measures.sectionProgress)
            val newHeaderProgress = uiState.headerProgress + (e.section to e.measures.headingProgress)
            val newViewPortProgress = uiState.viewPortProgress + (e.section to e.measures.viewPortProgress)

            val newActiveSection = getActiveSection(newHeaderProgress)
            val visiblesWithBackground = getVisibleBackgrounds(newViewPortProgress)

            val newBackgroundImageUrl = visiblesWithBackground.firstOrNull()?.key?.background
            val incoming = visiblesWithBackground.getOrNull(1)

            uiState = uiState.copy(
                sectionProgress = newSectionProgress,
                headerProgress = newHeaderProgress,
                viewPortProgress = newViewPortProgress,
                activeSection = newActiveSection,
                background = newBackgroundImageUrl,
                incomingBackground = incoming?.key?.background,
                incomingTransition = incoming?.value ?: 0f,
            )
        }
        is IEVPPageEvent.SectionReached -> e.section.takeIf { it !in uiState.sectionReached }?.let {
            uiState = uiState.copy(sectionReached = uiState.sectionReached + it)
            PostHogClient.capture(IEVPJourney.SectionReached(it))
        }
    }

    private fun getActiveSection(headerProgress: Map<IEVPSection, Float>): IEVPSection = IEVPSection.entries
        .lastOrNull { (headerProgress[it] ?: 0f) >= 0.99f }
        ?: uiState.activeSection

    private fun getVisibleBackgrounds(viewPortProgress: Map<IEVPSection, Float>): List<Map.Entry<IEVPSection, Float>> =
        viewPortProgress.entries
            .filter { it.key.background != null }
            .filter { it.value > 0f && it.value < 1f }
            .sortedBy { it.key.ordinal }
}
